import { IOffer } from "@nju/data-access-portal-offers";

export function sortByOfferPrice(a: IOffer, b: IOffer) {
  if (
    !a?.productOfferingPrice?.price.amount ||
    !b?.productOfferingPrice?.price.amount
  ) {
    return 1;
  }

  return (
    a.productOfferingPrice.price.amount - b.productOfferingPrice.price.amount
  );
}
